import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { faTools } from "@fortawesome/free-solid-svg-icons";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { faFaucet } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

library.add(faHome, faTools, faInfo, faFaucet, faPaperPlane, faPlusCircle);

const app = createApp(App)
  .use(router)
  .component("font-awesome-icon", FontAwesomeIcon)

app.config.globalProperties.axios = axios

app.mount('#app')
